import Login from "./Login";
import Menu from "./Menu";
import Header from "./Header";
import Footer from "./Footer";
import Hero from "./Hero";
import CategoryCard from "./CategoryCard";
import ProductCard from "./ProductCard";
import Search from "./Search";
import ImageCarousel from "./ImageCarousel";
import ItemQuantity from "./ItemQuantity";
import RadioCard from "./RadioCard";
import RadioInput from "./RadioInput";
import Pagination from "./Pagination";
import CartItem from "./CartItem";

const allFixtues = {
  Login,
  Menu,
  Header,
  Footer,
  Hero,
  CategoryCard,
  ProductCard,
  Search,
  ImageCarousel,
  ItemQuantity,
  RadioCard,
  RadioInput,
  Pagination,
  CartItem,
};

export default allFixtues;
